import React from 'react';

interface MetadataDisplayProps {
  metadataMap: Record<string, any>;
  className?: string;
}

export const MetadataDisplay: React.FC<MetadataDisplayProps> = ({ metadataMap, className = '' }) => {
  const query_entities = metadataMap?.query_entities;

  if (
    !metadataMap ||
    (!query_entities)
  ) {
    return null;
  }

  return (
    <div className={`flex flex-row flex-wrap gap-4 font-medium text-xs ${className}`}>
      <div className="flex flex-row flex-wrap gap-2 items-center">
      {/* Entities and Keywords as chips */}
      {(query_entities ) && (
        <span className="flex items-center gap-2">
          <div className="flex flex-wrap gap-1">
            {/* Query Entities */}
            {(Array.isArray(query_entities) ? query_entities : [query_entities])
              .map((query_entities) => (
                <div className="border border-default-300 bg-default-100 px-2 py-1 rounded text-foreground" key={`query_entities-${query_entities}`}>[{query_entities}]</div>
              ))}
          </div>
        </span>
      )}
      </div>
    </div>
  );
};

export default MetadataDisplay;
